/* Tailgater Supply GA4 events. Page views and add_to_cart already come from the Google & YouTube
   app's sandboxed pixel. The theme loads its own G-RCD314Q5VR tag (snippets/stylesheets.liquid, page views
   off) so these events have a gtag, and adds only what the app can't see:
   sign_up (Pregame), generate_lead (nominate / crew / contact / bulk / restock), affiliate_click, video_start,
   select_promotion (Kit cards and the Pregame CTAs), and [data-tg-tap] card taps (home_finds_tap, v39). Every event carries page_type + page_slug
   so revenue and signups tie back to the guide or post that earned them (CRO §9).
   Does nothing if gtag isn't on the page. */
(function () {
  if (window.tgTrack) return;
  window.tgTrack = true;

  var parts = location.pathname.split('/').filter(Boolean);
  var pageType = parts.length === 0 ? 'home'
    : parts[0] === 'products' ? 'product'
    : parts[0] === 'collections' ? 'collection'
    : parts[0] === 'blogs' && parts[1] === 'stadium-guides' ? (parts.length > 2 && parts[2] !== 'tagged' ? 'guide' : 'guide_index')
    : parts[0] === 'blogs' ? (parts.length > 2 && parts[2] !== 'tagged' ? 'article' : 'blog')
    : parts[0] === 'pages' ? 'page'
    : parts[0] === 'search' ? 'search'
    : parts[0];
  var pageSlug = parts[parts.length - 1] || 'home';

  // v40: first-touch UTMs for the session (guide signups put them on the Klaviyo profile).
  try {
    var qp = new URLSearchParams(location.search), ft = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { if (qp.get(k)) ft[k] = qp.get(k).slice(0, 120); });
    if (ft.utm_source && !sessionStorage.getItem('tg_ft')) sessionStorage.setItem('tg_ft', JSON.stringify(ft));
  } catch (e) {}

  function send(name, params) {
    if (typeof window.gtag !== 'function') return;
    params = params || {};
    params.page_type = pageType;
    params.page_slug = pageSlug;
    params.page_path = location.pathname;
    window.gtag('event', name, params);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var tags = form.querySelector('[name="contact[tags]"]');
    var kind = form.querySelector('[name="contact[Form]"]');
    if (tags && /pregame|newsletter/.test(tags.value)) {
      send('sign_up', { method: 'pregame', team: (tags.value.match(/team-([a-z0-9-]+)/) || [])[1] || 'none' });
    } else if (form.querySelector('[name="contact[Also send The Pregame]"]:checked')) {
      send('sign_up', { method: 'guide_email', team: 'none' });
    } else if (kind) {
      send('generate_lead', { form_name: kind.value });
    } else if (tags && /restock/.test(tags.value)) {
      send('generate_lead', { form_name: 'restock' });
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var out = e.target.closest('[data-tg-outbound]');
    if (out) {
      send('affiliate_click', {
        retailer: out.getAttribute('data-tg-outbound'),
        product: out.getAttribute('data-tg-product') || (pageType === 'product' ? pageSlug : ''),
        row: out.getAttribute('data-tg-row') || '',
        link_url: out.href
      });
    }
    var gear = e.target.closest('[data-tg-gear]');
    if (gear) send('select_item', { item_list_name: 'pack_it_in', item_id: gear.getAttribute('data-tg-gear'), link_url: gear.href });
    var play = e.target.closest('[data-sg-play]');
    if (play) {
      var block = play.closest('[data-sg-video]');
      send('video_start', { video_provider: 'youtube', video_id: block && block.getAttribute('data-sg-video') });
    }
    var kit = e.target.closest('.tg-cx__kit, .tgx-kit, [data-tg-kit]');
    if (kit) {
      send('select_promotion', { promotion_name: 'kit', creative_slot: kit.classList.contains('tg-cx__kit') ? 'cart_drawer' : pageType, link_url: kit.href });
    }
    // v39 CRO home test: card taps (home_finds_tap on the home Finds row), item = product handle, position = 1-3.
    var tap = e.target.closest('[data-tg-tap]');
    if (tap) {
      var tp = { item_id: tap.getAttribute('data-tg-item') || '', index: Number(tap.getAttribute('data-tg-pos')) || 0, link_url: tap.href };
      // v40 pregame_cta_click (guide → Pregame line): team, guide, position.
      ['team', 'guide', 'position', 'page'].forEach(function (k) { var v = tap.getAttribute('data-tg-' + k); if (v) tp[k] = v; });
      send(tap.getAttribute('data-tg-tap'), tp);
    }
    var cta = e.target.closest('[data-tg-cta]');
    if (cta) send('select_promotion', { promotion_name: 'pregame', creative_slot: cta.getAttribute('data-tg-cta') });
  }, true);
})();
